export default __webpack_public_path__ + "static/media/wallet-icon-active.f1f82bf8.svg";